<!-- 支付信息 -->
<template>
  <div class="systemLog">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input
          v-model.trim="query.query"
          placeholder="请输入考点名称"
          style="width: 200px"
          @keyup.enter.native="tableLoad"
          @clear="
            query.query = '';
            tableLoad();
          "
          clearable
          suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button style="margin:0px 10px;" size="small" @click="tableLoad"
            >查询</el-button
          >
        </Debounce>
      </el-col>
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%;"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      :height="$store.getters.getTableHeight"
    >
      <el-table-column
        prop="provinceName"
        label="省份名称"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="examSiteName"
        label="考点名称"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="region"
        label="所属区域"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="registrationPointName"
        width="200"
        label="考点名称"
        align="center"
      ></el-table-column>
      <el-table-column label="是否允许线上缴费" width="140" align="center">
        <template slot-scope="scope">
          <span :class="getIsTrue(scope.row.onlinePayment)">
            {{ scope.row.onlinePayment | filIsTrue }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="160" label="是否允许支付宝缴费" align="center">
        <template slot-scope="scope">
          <span :class="getIsTrue(scope.row.whetherRepeatAlipay)">
            {{ scope.row.whetherRepeatAlipay | filIsTrue }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="是否允许微信缴费" width="160" align="center">
        <template slot-scope="scope">
          <span :class="getIsTrue(scope.row.whetherRepeatWxpay)">
            {{ scope.row.whetherRepeatWxpay | filIsTrue }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        prop="aliAppId"
        label="aliAppId"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="aliPrivateKey"
        label="aliPrivateKey"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        width="200"
        prop="aliPublicKey"
        label="aliPublicKey"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="wxAppId"
        width="200"
        label="wxAppId"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="wxMchId"
        label="wxMchId"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="wxMchKey"
        width="200"
        label="wxMchKey"
        align="center"
      ></el-table-column>
      <el-table-column
        fixed="right"
        width="120"
        label="修改缴费信息"
        align="center"
      >
        <template slot-scope="scope">
          <Debounce>
            <el-button type="text" size="small" @click="operatRow(scope.row, 1)"
              >支付宝</el-button
            >
          </Debounce>
          <span style="margin:0px 10px">|</span>
          <Debounce>
            <el-button type="text" size="small" @click="operatRow(scope.row, 2)"
              >微信</el-button
            >
          </Debounce>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="query.total"
      :page.sync="query.pageNum"
      :limit.sync="query.pageSize"
      class="pagination-content"
      @pagination="tableLoad"
    />
    <el-dialog
      custom-class="dailogComponents"
      title="修改缴费信息"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      v-if="visible"
      width="360px"
    >
      <div class="dialogBox">
        <el-row type="flex" justify="space-around">
          <span>
            {{ visibleType == 1 ? "是否允许支付宝缴费" : "是否允许微信缴费" }}
          </span>
          <div>
            <el-radio v-model="submitObj.onlinePayment" :label="1">是</el-radio>
            <el-radio v-model="submitObj.onlinePayment" :label="0">否</el-radio>
          </div>
        </el-row>
        <template v-if="visibleType == 1">
          <el-input
            v-model="submitObj.aliAppId"
            placeholder="请输入aliAppId"
          ></el-input>
          <el-input
            v-model="submitObj.aliPrivateKey"
            placeholder="请输入aliPrivateKey"
          ></el-input>
          <el-input
            v-model="submitObj.aliPublicKey"
            placeholder="请输入aliPublicKey"
          ></el-input>
        </template>
        <template v-else>
          <el-input
            v-model="submitObj.wxAppId"
            placeholder="请输入wxAppId"
          ></el-input>
          <el-input
            v-model="submitObj.wxMchId"
            placeholder="请输入wxMchId"
          ></el-input>
          <el-input
            v-model="submitObj.wxMchKey"
            placeholder="请输入wxMchKey"
          ></el-input>
        </template>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-button size="medium" @click="visible = false">取消</el-button>
          <Debounce>
            <el-button size="medium" type="primary" @click="submit"
              >确认</el-button
            >
          </Debounce>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableList: [],
      tableIsLoad: false,
      visible: false,
      visibleType: 1, //删除
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
      },
      submitObj: {
        aliAppId: "",
        aliPrivateKey: "",
        aliPublicKey: "",
        wxAppId: "",
        wxMchId: "",
        wxMchKey: "",
        onlinePayment: 0,
      },
    };
  },
  filters: {
    filIsTrue(val) {
      return !!val ? "是" : "否";
    },
  },
  mounted() {
    this.tableLoad();
  },
  methods: {
    tableLoad() {
      this.$axios.put("/assigns/pay/setting/list", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    submit() {
      let path = "";
      let {
        aliAppId,
        aliPrivateKey,
        aliPublicKey,
        wxAppId,
        wxMchId,
        wxMchKey,
        onlinePayment,
        id,
      } = this.submitObj;
      let subObj = {};
      if (this.visibleType == 1) {
        path = "/assigns/update/alipay";
        subObj = {
          whetherRepeatAlipay: !!onlinePayment,
          aliAppId,
          aliPrivateKey,
          aliPublicKey,
          id,
        };
      } else {
        path = "/assigns/update/wxpay";
        subObj = {
          whetherRepeatWxpay: !!onlinePayment,
          wxAppId,
          wxMchId,
          wxMchKey,
          id,
        };
      }
      this.$axios.put(path,subObj).then((res) => {
        this.$message({ type: "success", message: "修改成功!" ,duration:1000});
        this.visible = false;
        this.tableLoad();
      });
    },
    operatRow(row, type) {
      this.submitObj = JSON.parse(JSON.stringify(row));
      this.visible = true;
      this.visibleType = type;
    },
    getIsTrue(val) {
      return !!val ? "greSpan" : "redSpan";
    },
  },
};
</script>
<style lang="scss" scoped>
.systemLog {
  .redSpan {
    color: #f56c6c;
  }
  .greSpan {
    color: #67c23a;
  }
  .dialogBox {
    .el-input {
      margin-top: 20px;
    }
  }
}
</style>
